import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=1112a02c&scoped=true"
import script from "./BankSlip.vue?vue&type=script&lang=ts"
export * from "./BankSlip.vue?vue&type=script&lang=ts"
import style0 from "./BankSlip.vue?vue&type=style&index=0&id=1112a02c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1112a02c",
  null
  
)

export default component.exports